import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdminKycApplicationDetailsDto } from '../../_core/_model/compliance';
import { ComplianceApiService } from '../../_core/_services/_compliance/compliance-api.service';
import { NotificationService } from '../../_core/_services/notification.service';

@Component({
  selector: 'app-admin-kyc-review-details',
  standalone: false,
  templateUrl: './admin-kyc-review-details.html',
  styleUrl: './admin-kyc-review-details.css',
})
export class AdminKycReviewDetails implements OnInit {
  loading = false;
  applicationId = '';
  item: AdminKycApplicationDetailsDto | null = null;
  backendHint = false;

  constructor(
    private route: ActivatedRoute,
    private api: ComplianceApiService,
    private notify: NotificationService,
  ) {}

  ngOnInit(): void {
    this.applicationId = this.route.snapshot.paramMap.get('applicationId') || '';
    this.load();
  }

  load(): void {
    if (!this.applicationId) return;
    this.loading = true;
    this.backendHint = false;
    this.api.getAdminReviewById(this.applicationId).subscribe({
      next: (res) => {
        this.item = res.data || null;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        if (err?.status === 404) {
          this.backendHint = true;
          return;
        }
        this.notify.showError(err?.error?.error?.details || err?.error?.message || 'Unable to load review details.', 'Compliance');
      }
    });
  }

  approveDocument(documentId: string): void {
    this.api.approveDocument(documentId, 'Approved from admin review details').subscribe({
      next: (res) => {
        this.notify.showSuccess(res.message || 'Document approved.', 'Compliance');
        this.load();
      },
      error: (err) => this.notify.showError(err?.error?.error?.details || err?.error?.message || 'Unable to approve document.', 'Compliance')
    });
  }

  rejectDocument(documentId: string): void {
    const reason = window.prompt('Enter rejection reason');
    if (!reason) return;
    this.api.rejectDocument(documentId, reason).subscribe({
      next: (res) => {
        this.notify.showSuccess(res.message || 'Document rejected.', 'Compliance');
        this.load();
      },
      error: (err) => this.notify.showError(err?.error?.error?.details || err?.error?.message || 'Unable to reject document.', 'Compliance')
    });
  }

  startReview(): void {
    this.api.startReview(this.applicationId, 'Started from details page').subscribe({
      next: (res) => {
        this.notify.showSuccess(res.message || 'Application moved to under review.', 'Compliance');
        this.load();
      },
      error: (err) => this.notify.showError(err?.error?.error?.details || err?.error?.message || 'Unable to start review.', 'Compliance')
    });
  }

  approveApplication(): void {
    this.api.approveApplication(this.applicationId, 'Approved from details page').subscribe({
      next: (res) => {
        this.notify.showSuccess(res.message || 'Application approved.', 'Compliance');
        this.load();
      },
      error: (err) => this.notify.showError(err?.error?.error?.details || err?.error?.message || 'Unable to approve application.', 'Compliance')
    });
  }

  rejectApplication(): void {
    const reason = window.prompt('Enter rejection reason');
    if (!reason) return;
    this.api.rejectApplication(this.applicationId, reason).subscribe({
      next: (res) => {
        this.notify.showSuccess(res.message || 'Application rejected.', 'Compliance');
        this.load();
      },
      error: (err) => this.notify.showError(err?.error?.error?.details || err?.error?.message || 'Unable to reject application.', 'Compliance')
    });
  }
}
